import { useEffect, useRef } from 'react';
import { useJiraSoftwareProjectNavigation } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/project-sidebar-navigation-resource/index.tsx';
import { useFeature } from './board-features/index.tsx';
import type { UseFeatureTogglePropsParams } from './types.tsx';

export const useFeatureToggleProps = ({
	boardId,
	featureStatusList,
}: UseFeatureTogglePropsParams) => {
	const [{ isFetchError }, { fetchFeatures, syncFeatures }] = useFeature();
	const { refresh } = useJiraSoftwareProjectNavigation();

	const shouldSyncFeatures = useRef(true);

	useEffect(() => {
		if (boardId) {
			fetchFeatures(boardId);
		}
	}, [boardId, fetchFeatures]);

	useEffect(() => {
		// only sync feature when popup is not opened,
		// otherwise state control is given to the popup
		if (shouldSyncFeatures.current === true) {
			syncFeatures(featureStatusList);
		}
	}, [featureStatusList, syncFeatures]);

	return { isFetchError, shouldSyncFeatures, refreshSidebar: refresh };
};
